import { useOutletContext } from "react-router-dom";

const OutletContextToPropsHOC = (props: any) => {
    const context = useOutletContext()
    return <props.element {...context} />
}

export default OutletContextToPropsHOC;